export default __webpack_public_path__ + "static/media/checkbox.9f01fc67.svg";